export const COMMUNITY = {

  'NO_PROJECTS': 'Nous n\'avons pas de projets à montrer pour le moment.',

};
